import * as actions from './erratas.action';
import inicialState from './erratas.state';

const erratasReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.ATUALIZAR_ERRATA:
      return {
        ...state,
        errata: action.payload.errata,
      };
    case actions.SELECT_ERRATA:
      return {
        ...state,
        selectErrata: action.payload.selectErrata,
      };
    default:
      return state;
  }
};

export default erratasReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/erratas/erratas.reducer.js